module.exports = __webpack_public_path__ + "media/ab-homepage/device-pdf-47e5d16c.png";